var map = {
	"./BEc_man.svg": 8305,
	"./BEc_woman.svg": 3523,
	"./BEn_man.svg": 6336,
	"./BEn_woman.svg": 1610,
	"./BM_man.svg": 6764,
	"./BM_woman.svg": 3654,
	"./C_man.svg": 3248,
	"./C_woman.svg": 746,
	"./EcEn_man.svg": 274,
	"./EcEn_woman.svg": 6431,
	"./EcM_man.svg": 7254,
	"./EcM_woman.svg": 9440,
	"./En-Ec_man.svg": 8389,
	"./En-Ec_woman.svg": 8631,
	"./EnEc_man.svg": 7830,
	"./EnEc_woman.svg": 4128,
	"./EnM_man.svg": 5809,
	"./EnM_woman.svg": 9571,
	"./M-Ec_man.svg": 6113,
	"./M-Ec_woman.svg": 6531,
	"./M-En_man.svg": 2336,
	"./M-En_woman.svg": 1850,
	"./MEc_man.svg": 8354,
	"./MEc_woman.svg": 8924,
	"./MEn_man.svg": 5651,
	"./MEn_woman.svg": 8181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5026;